import request from './utils/request';

/**
 * 获取微信登录二维码
 * 后端接口：/web/wechat/getQrCode
 * @returns {Promise} 返回 { code: 200, data: { sceneId, qrCodeUrl } }
 */
export function getQrCode() {
  return request({
    url: '/web/wechat/getQrCode',
    method: 'get'
  });
}

/**
 * 检查微信扫码登录状态进行登录
 * 后端接口：/web/wechat/checkLogin
 * 返回格式：{ code: 200, data: { status, token, user } }
 * status: 'waiting' | 'scanned' | 'Success' | 'expired'
 * @param {String} sceneId - 二维码sceneId
 * @returns {Promise} 返回请求结果Promise对象
 */
export function checkWechatQrCodeStatusLogin(sceneId) {
  return request({
    url: '/web/wechat/checkLogin',
    method: 'get',
    params: { sceneId }
  });
}


/**
 * 个人手机号验证码登录
 * @param {string} phoneNumber - 个人手机号
 * @param {string} smsCode - 短信验证码
 * @returns {Promise} 登录结果，包含token
 */
export function personalSmsLogin(phoneNumber, smsCode) {
  return request({
    url: '/web/login/personal/sms',
    method: 'post',
    params: {
      phoneNumber: phoneNumber,
      smsCode: smsCode
    }
  })
}

/**
 * 个人手机号验证码登录 - 获取登录验证码
 * 由后端校验手机号是否已通过扫码注册个人账号，未注册时返回业务失败。
 * @param {string} phoneNumber - 个人手机号
 * @returns {Promise} 验证码发送结果
 */
export function getPersonalSmsLoginCaptcha(phoneNumber) {
  return request({
    url: '/web/login/personal/sms/captcha',
    method: 'get',
    params: {
      phoneNumber: phoneNumber
    },
    skipGlobalErrorHandler: true
  })
}

/**
 * 企业个人管理员手机号验证码登录
 * @param {string} phoneNumber - 个人管理员手机号
 * @param {string} smsCode - 短信验证码
 * @returns {Promise} 登录结果，包含token
 */
export function enterprisePersonalAdminSmsLogin(personalAdminPhoneNumber, smsCode) {
  return request({
    url: '/web/login/enterpriseAdmin/sms',
    method: 'post',
    params: {
      phoneNumber: personalAdminPhoneNumber,
      smsCode: smsCode
    }
  })
}

/**
 * 企业账号密码登录
 * @param {string} account - 企业账号（统一社会信用代码或登录账号）
 * @param {string} password - 密码
 * @returns {Promise} 登录结果，包含token
 */
export function enterpriseAccountLogin(account, password) {
  return request({
    url: '/web/login/enterprise/account',
    method: 'post',
    params: {
      account: account,
      password: password
    }
  })
}

/**
 * 企业账号密码找回
 * @param {string} account - 主体账号（统一社会信用代码或登录账号）
 * @param {string} phoneNumber - 主体联系人电话
 * @param {string} smsCode - 短信验证码
 * @returns {Promise} 找回结果
 */
export function retrieveEnterprisePassword(account, phoneNumber, smsCode) {
  return request({
    url: '/web/login/enterprise/retrievePassword',
    method: 'post',
    params: {
      account: account,
      phoneNumber: phoneNumber,
      smsCode: smsCode
    }
  })
}

/**
 * 绑定手机号
 */
export function bindPhone(phoneNumber, smsCode) {
  return request({
    url: '/web/portal/userCenter/bindingCurrentPersonalUserMobile',
    method: 'post',
    params: { phoneNumber, smsCode }
  });
}

/**
 * 获取当前用户信息（基础信息）
 */
export function getCurrentUserInfo() {
  return request({
    url: '/web/portal/userCenter/getCurrentUserInfo',
    method: 'get'
  });
}

/**
 * 获取当前登录用户的详细信息（个人用户）
 */
export function getCurrentUserDetail() {
  return request({
    url: '/web/portal/userCenter/getCurrentUserDetail',
    method: 'get'
  });
}


/**
 * 退出登录
 */
export function logout() {
  return request({
    url: '/web/login/logout',
    method: 'post'
  });
}

/**
 * 切换登录身份
 * @param {string|number} [entId] - 企业ID；有值则切换到该企业，不传/为空则切换回个人身份
 * @returns {Promise} 返回新的 LoginTokenVo（含 token）
 */
export function switchUser(entId) {
  const params = {}
  if (entId !== undefined && entId !== null && entId !== '') {
    params.entId = entId
  }
  return request({
    url: '/web/login/switchUser',
    method: 'post',
    params
  });
}

/**
 * 获取当前可切换的身份列表（再次打开「选择管理用户」弹窗时使用）
 * @returns {Promise} { canSwitchIdentity, personalIdentity, enterpriseIdentities, currentMainBodyType, currentMainBodyId }
 */
export function getLoginIdentities() {
  return request({
    url: '/web/login/identities',
    method: 'get'
  });
}

